"use client"

import { useState } from "react"

const InsuranceForm = ({ onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    item_name: "",
    description: "",
    quantity: 1,
    cost_price: 0,
    selling_price: 0,
    margin: 0,
    item_type: "insurance",
    // Insurance specific fields
    insurance_type: "",
    coverage_amount: "",
    policy_duration: "",
    insured_name: "",
    age: "",
    destination: "",
    start_date: "",
    end_date: "",
  })

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => {
      const updated = { ...prev, [name]: value }

      // Auto-calculate margin and total when prices change
      if (name === "cost_price" || name === "selling_price") {
        const costPrice = Number.parseFloat(name === "cost_price" ? value : updated.cost_price) || 0
        const sellingPrice = Number.parseFloat(name === "selling_price" ? value : updated.selling_price) || 0

        if (costPrice > 0) {
          updated.margin = Math.round(((sellingPrice - costPrice) / costPrice) * 100)
        }
        updated.total_amount = sellingPrice * updated.quantity
      }

      if (name === "quantity") {
        updated.total_amount = updated.selling_price * Number.parseInt(value)
      }

      return updated
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit(formData)
  }

  return (
    <form onSubmit={handleSubmit} className="item-form">
      <div className="form-grid">
        <div className="form-group">
          <label>Item Name *</label>
          <input
            type="text"
            name="item_name"
            value={formData.item_name}
            onChange={handleInputChange}
            placeholder="e.g., Travel Insurance Policy"
            required
          />
        </div>

        <div className="form-group">
          <label>Insurance Type *</label>
          <select name="insurance_type" value={formData.insurance_type} onChange={handleInputChange} required>
            <option value="">Select Insurance Type</option>
            <option value="travel">Travel Insurance</option>
            <option value="health">Health Insurance</option>
            <option value="life">Life Insurance</option>
            <option value="vehicle">Vehicle Insurance</option>
            <option value="property">Property Insurance</option>
          </select>
        </div>

        <div className="form-group">
          <label>Insured Name *</label>
          <input
            type="text"
            name="insured_name"
            value={formData.insured_name}
            onChange={handleInputChange}
            placeholder="Full name of insured person"
            required
          />
        </div>

        <div className="form-group">
          <label>Age</label>
          <input
            type="number"
            name="age"
            value={formData.age}
            onChange={handleInputChange}
            min="1"
            max="100"
            placeholder="Age of insured person"
          />
        </div>

        <div className="form-group">
          <label>Coverage Amount *</label>
          <input
            type="number"
            name="coverage_amount"
            value={formData.coverage_amount}
            onChange={handleInputChange}
            placeholder="e.g., 100000"
            required
          />
        </div>

        <div className="form-group">
          <label>Policy Duration *</label>
          <select name="policy_duration" value={formData.policy_duration} onChange={handleInputChange} required>
            <option value="">Select Duration</option>
            <option value="7_days">7 Days</option>
            <option value="15_days">15 Days</option>
            <option value="30_days">30 Days</option>
            <option value="60_days">60 Days</option>
            <option value="90_days">90 Days</option>
            <option value="1_year">1 Year</option>
          </select>
        </div>

        <div className="form-group">
          <label>Destination</label>
          <input
            type="text"
            name="destination"
            value={formData.destination}
            onChange={handleInputChange}
            placeholder="Travel destination (if applicable)"
          />
        </div>

        <div className="form-group">
          <label>Start Date *</label>
          <input type="date" name="start_date" value={formData.start_date} onChange={handleInputChange} required />
        </div>

        <div className="form-group">
          <label>End Date *</label>
          <input type="date" name="end_date" value={formData.end_date} onChange={handleInputChange} required />
        </div>

        <div className="form-group">
          <label>Quantity *</label>
          <input
            type="number"
            name="quantity"
            value={formData.quantity}
            onChange={handleInputChange}
            min="1"
            required
          />
        </div>

        <div className="form-group">
          <label>Cost Price *</label>
          <input
            type="number"
            name="cost_price"
            value={formData.cost_price}
            onChange={handleInputChange}
            step="0.01"
            min="0"
            required
          />
        </div>

        <div className="form-group">
          <label>Selling Price *</label>
          <input
            type="number"
            name="selling_price"
            value={formData.selling_price}
            onChange={handleInputChange}
            step="0.01"
            min="0"
            required
          />
        </div>
      </div>

      <div className="form-group full-width">
        <label>Description</label>
        <textarea
          name="description"
          value={formData.description}
          onChange={handleInputChange}
          placeholder="Additional details about the insurance policy..."
          rows="3"
        />
      </div>

      <div className="pricing-summary">
        <div className="summary-item">
          <span>Margin: {formData.margin}%</span>
        </div>
        <div className="summary-item">
          <span>Total Amount: ${(formData.selling_price * formData.quantity).toFixed(2)}</span>
        </div>
      </div>

      <div className="form-actions">
        <button type="button" className="btn-secondary" onClick={onCancel}>
          Cancel
        </button>
        <button type="submit" className="btn-primary">
          Add Insurance Policy
        </button>
      </div>
    </form>
  )
}

export default InsuranceForm
